import React from 'react';
import { useTranslation } from 'react-i18next';
import MemberIdImg from '../../assets/images/memberidcard_img.png';
import { Headings, Paragraph } from '@sentara-health/optimahealth_web';

function MemberIdOverlay() {
  const { t } = useTranslation();
  return (
    <div className="memoverlay-content">
      <Headings
        level={5}
        text={t('common.memberIDCardToolTipHeader')}
        variant="regular"
        data-testid="memIDCardToolTipHeader"
        className="memoverlay-title mb-2"
      />
      <Paragraph
        text={t('common.memberIDCardToolTipText1')}
        data-testid="memIDCardToolTipDescOne"
        variant="regular"
        className="mb-3"
      />

      <div className="pb-3 text-center">
        <img src={MemberIdImg} alt="Member Id Card" className="img-fluid" />
      </div>
      <Paragraph
        text={
          <>
            {t('common.memberIDCardToolTipText4')}{' '}
            {t('activation.memberIDCardToolTipText5')}
          </>
        }
        data-testid="memIDCardToolTipDescTwo"
        className="mb-0"
      />
    </div>
  );
}

export default MemberIdOverlay;
